export const config = {
  databaseURL: "https://synchro-nus.firebaseio.com",
}